//@ts-nocheck
import React, { useState } from 'react'
import { Transforms } from 'slate'
import { ReactEditor } from 'slate-react'
import { ModalBody, ModalHeader, ModalFooter, Button, ButtonGroup, Icon } from '../../../../../../index'

import { ImageEditForm } from './ImageEditForm'
//@ts-ignore
import styles from './style.module.css'
import { handleImageError } from './withImage'

export const ImageEditModal = ({ element, editor, type, ...props }) => {
  const [updatedFormData, setUpdatedFormData] = useState()
  const [hasError, setHasError] = useState(false)

  const updateFormData = (formData) => {
    setUpdatedFormData(formData)
  }

  const handleFormSubmit = (values) => {
    let fields = { ...values }

    if (fields['inline']) {
      if (fields['position'] === 'center' || !fields['position']) {
        /* istanbul ignore next */
        fields['position'] = 'left'
      }
    }
    const path = ReactEditor.findPath(editor, element)

    const newAttributes = {
      ...element.attrs,
      "redactor-attributes": {
        ...element.attrs?.["redactor-attributes"]
      },
      style: {
        ...element.attrs?.style
      }
    }
    Object.entries(fields).forEach(([f, v]) => {
      const field = f
      const value: any = v
      if (value && value !== '') {
        newAttributes["redactor-attributes"][field] = value
        if (field === 'inline') {
          newAttributes['inline'] = value
        }

        if (field === 'alt') {
          if (type === 'asset')
            /* istanbul ignore next */
            newAttributes['asset-alt'] = value.trim();
          else
            newAttributes['alt'] = value
        }

        if (field === 'url') {
          newAttributes['url'] = value
        }
        if (field === 'caption' || field === 'anchorLink') {
          /* istanbul ignore if */
          if (type === 'asset') {
            if (field === 'caption')
              newAttributes['asset-caption'] = value.trim();
            else newAttributes['link'] = value.trim();
          }
          else
            newAttributes[field] = value.trim()
        }

        if (field === 'position') {
          /* istanbul ignore if */
          if (type === 'asset') {
            newAttributes['position'] = value;
          }
          if (value === 'none') {
            newAttributes["redactor-attributes"]['position'] = 'none'
            delete newAttributes.style["text-align"]
            delete newAttributes.style["text-align"]
            delete newAttributes.style["float"]
            delete newAttributes.style["width"]
            delete newAttributes.style["max-width"]
            delete newAttributes['max-width']
          } else {
            newAttributes.style["text-align"] = value
            newAttributes["redactor-attributes"]['position'] = value

            if (value !== 'center') {
              if (newAttributes['max-width']) {
                newAttributes.style["max-width"] = `${newAttributes['max-width']}px`
                newAttributes['max-width'] = newAttributes['max-width']
                newAttributes.style["width"] = `${newAttributes.width}px`
                newAttributes['width'] = newAttributes.width
              }
              else {
                newAttributes.style["max-width"] = `${newAttributes['width']}px`
                newAttributes['max-width'] = newAttributes['width']
              }
              newAttributes.style["float"] = value
            }
            else {
              if (newAttributes['max-width']) {
                newAttributes['width'] = newAttributes['max-width']
                delete newAttributes.style["float"]
                delete newAttributes.style["width"]
                delete newAttributes.style["max-width"]
                delete newAttributes['max-width']
              }
            }
          }
        }
        if (field === 'target') {
          newAttributes.target = value ? '_blank' : '_self';
        }
      } else {
        if (field === 'position') {
          delete newAttributes.style["text-align"]
        }
        delete newAttributes[field]
        delete newAttributes["redactor-attributes"][field]
      }
    })
    Transforms.setNodes(editor, { attrs: newAttributes }, { at: path })
    props.closeModal()
  }

  return (
    <div>
      <ModalHeader title="Edit Image" closeModal={props.closeModal} />

      <ModalBody>
        <div className={styles['scrte-form-container']}>
          <div>
            <img src={type === 'asset' ? element.attrs?.['asset-link'] : element.attrs.url} className={styles['modal']} onError={handleImageError} data-testid={'scrte-image-element'} />
          </div>
          <div>
            <ImageEditForm
              attributes={{
                ...element?.attrs,
                ...element?.attrs?.["redactor-attributes"]
              }}
              updateFormData={updateFormData}
              hasError={{ value: hasError, callback: setHasError }}
            />
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <Button key="cancel" buttonType="light" onClick={() => props.closeModal()} data-testid={'scrte-cancel'}>
            Cancel
          </Button>
          <Button
            icon={'SaveWhite'}
            key="add"
            disabled={hasError}
            onClick={() => {
              handleFormSubmit(updatedFormData)
            }}
            data-testid={'scrte-submit'}
          >
            Save
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  )
}
